const clientKeys = [
	'name',
	'short_name',
	'bucket_prefix',
	'image_archive_url_pattern',
	'is_main_client',
	'show_image_ownership',
	'agreement_gcs_uri',
	'agreement_vrg_gcs_uri',
	'logo',
	'website',
	'website_vrg',
	'description',
	'inactive',
	'scans_paused',
	'groups'
]

const clientSettingsKeys = [
	'currency',
	'notify_on_slack',
	'byline_names',
	'terms_version',
	'service_agreement_version',
	'soft_claim',
	'organization_number',
	'address',
	'city',
	'postal_code',
	'country_name',
	'registration_certificates_enabled',
	'transfer_agreements_enabled',
	'force_upload_to_registered_image_pipeline_enabled',
	'partner_type',
]

const clientTargetsKeys = ['reviewed_cases_monthly_target']

export const formatClientData = (client) => {
	const formattedClient = {
		client: {},
		settings: {},
		targets: {},
		filters: {},
	}

	Object.keys(client).forEach((key) => {
		if (clientKeys.includes(key)) formattedClient.client[key] = client[key]
		if (clientSettingsKeys.includes(key))
			formattedClient.settings[key] = client[key]
		if (clientTargetsKeys.includes(key))
			formattedClient.targets[key] = client[key]
	})

	return formattedClient
}
